import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Suspense as _Suspense, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "poll-page" }
const _hoisted_2 = { class: "poll-content" }
const _hoisted_3 = {
  key: 2,
  class: "gu-actions-right"
}
const _hoisted_4 = { class: "designs-note" }
const _hoisted_5 = { class: "designs-list" }
const _hoisted_6 = { class: "design-name" }
const _hoisted_7 = {
  key: 0,
  class: "design-group"
}
const _hoisted_8 = { class: "design-group-header" }
const _hoisted_9 = { class: "design-name" }
const _hoisted_10 = { class: "gu-actions-right" }
const _hoisted_11 = {
  key: 1,
  class: "poll-layout"
}
const _hoisted_12 = { class: "poll-sidebar" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "chapter-number" }
const _hoisted_15 = { class: "chapter-title" }
const _hoisted_16 = { class: "chapter-subtitle" }
const _hoisted_17 = { class: "chapter-number" }
const _hoisted_18 = { class: "poll-main" }
const _hoisted_19 = { class: "chapter-header" }
const _hoisted_20 = { class: "question-list" }
const _hoisted_21 = { class: "poll-nav" }
const _hoisted_22 = {
  key: 2,
  class: "gu-actions-right"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "designs-note" }
const _hoisted_25 = { class: "designs-list" }
const _hoisted_26 = { class: "design-name" }
const _hoisted_27 = {
  key: 0,
  class: "design-group"
}
const _hoisted_28 = { class: "design-group-header" }
const _hoisted_29 = { class: "design-name" }
const _hoisted_30 = { class: "poll-nav" }
const _hoisted_31 = { class: "gu-actions-right" }
const _hoisted_32 = { class: "gu-confirm-icon" }
const _hoisted_33 = { class: "gu-confirm-actions" }


import {
  ref,
  computed,
  defineAsyncComponent,
  onMounted,
} from 'vue';
import { storeToRefs } from 'pinia';
// eslint-disable-next-line import/no-cycle
import { useEcoHospitalStore } from '~store/ecohospital/ecohospitalModule';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store';
import AppLoader from '@/components/AppLoader.vue';

const __default__ = { name: 'PollPage' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const ecoStore = useEcoHospitalStore();
const { poll } = storeToRefs(ecoStore);

const designList = ref<any[]>([]);

onMounted(async () => {
  await ecoStore.getPoll();
  designList.value = await ecoStore.getDesignList();
});

const step = ref(1);
const done = ref(false);
const isMobile = computed(() => window.innerWidth < 900);

const labDesigns = computed(() => designList.value.filter((d) => !!d.lab));
const regularDesigns = computed(() => designList.value.filter((d) => !d.lab));
const hasDesigns = computed(() => designList.value.length > 0);

const designStepNumber = computed(() => poll.value.length + 1);
const totalSteps = computed(() => poll.value.length + (hasDesigns.value ? 1 : 0));

const defineFieldType = computed(() => (type: string) => defineAsyncComponent(() => import(`~components/fields/${type}Field.vue`)));

const captureAnswer = (context:any) => {
  const qI = poll.value[step.value - 1].questions
    .findIndex((i) => i.number === context.number);

  if (qI > -1) poll.value[step.value - 1].questions[qI].answers = context.answers;
};

const prevStep = async (chapter:any) => {
  await ecoStore.sendChaptersAnswers({
    page: step.value,
    chapter,
  });

  step.value -= 1;
};

const nextStep = async (chapter:any) => {
  await ecoStore.sendChaptersAnswers({
    page: step.value,
    chapter,
  });

  step.value += 1;
};

const showFinishConfirm = ref(false);
const creatingPollFile = ref(false);

const continueLater = async () => {
  const lastChapter = poll.value[poll.value.length - 1];

  await ecoStore.sendChaptersAnswers({
    page: lastChapter.chapter_number,
    chapter: lastChapter,
  });

  goToMain();
};

const openFinishConfirm = () => {
  showFinishConfirm.value = true;
};

const confirmFinishPoll = async () => {
  creatingPollFile.value = true;

  try {
    const lastChapter = poll.value[poll.value.length - 1];

    await ecoStore.sendChaptersAnswers({
      page: lastChapter.chapter_number,
      chapter: lastChapter,
    });

    useMainStore().showMessage('Создаём документ. Появится в течение минуты в списке документов на подпись.');

    await ecoStore.createPollFile();

    showFinishConfirm.value = false;
    done.value = true;

    goToMain();
  } finally {
    creatingPollFile.value = false;
  }
};

const processingDesignIds = ref<number[]>([]);
const cancelingAllLab = computed(
  () => labDesigns.value.some((d) => processingDesignIds.value.includes(d.iddesign)),
);

const runCancelDesign = (iddesign: number, onSuccess: () => void) => {
  processingDesignIds.value.push(iddesign);

  ecoStore.cancelDesign(iddesign)
    .then(onSuccess)
    .catch(() => {})
    .finally(() => {
      processingDesignIds.value = processingDesignIds.value.filter((id) => id !== iddesign);
    });
};

const toggleDesign = (design: any) => {
  const { iddesign } = design;

  runCancelDesign(iddesign, () => {
    const target = designList.value.find((item) => item.iddesign === iddesign);
    if (target) target.canceled = !target.canceled;
  });
};

const cancelAllLabDesigns = () => {
  labDesigns.value
    .filter((d) => !d.canceled)
    .forEach((design) => {
      const { iddesign } = design;

      runCancelDesign(iddesign, () => {
        const target = designList.value.find((item) => item.iddesign === iddesign);
        if (target) target.canceled = true;
      });
    });
};
// function resetPoll() {
//   done.value = false;
//   step.value = 1;
// }

const goToMain = () => {
  router.push({
    name: 'HealthPageFull',
  });
};


return (_ctx: any,_cache: any) => {
  const _component_q_breadcrumbs_el = _resolveComponent("q-breadcrumbs-el")!
  const _component_q_breadcrumbs = _resolveComponent("q-breadcrumbs")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_stepper_navigation = _resolveComponent("q-stepper-navigation")!
  const _component_q_step = _resolveComponent("q-step")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_stepper = _resolveComponent("q-stepper")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_q_breadcrumbs, {
        "active-color": "blue-10",
        "separator-color": "blue-10",
        class: "text-blue-grey-10"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_breadcrumbs_el, {
            class: "cursor-pointer",
            label: "Главная",
            icon: "home",
            onClick: goToMain
          }),
          _createVNode(_component_q_breadcrumbs_el, {
            label: "Анкетирование",
            icon: "ballot"
          })
        ]),
        _: 1
      }),
      (isMobile.value)
        ? (_openBlock(), _createBlock(_component_q_stepper, {
            key: 0,
            modelValue: step.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((step).value = $event)),
            vertical: "",
            animated: "",
            "header-nav": "",
            color: "accent",
            "active-color": "blue-grey-8",
            "done-color": "light-green-6",
            "keep-alive": ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(poll), (chapter) => {
                return (_openBlock(), _createBlock(_component_q_step, {
                  key: chapter.chapter_number,
                  name: chapter.chapter_number,
                  title: chapter.chapter,
                  caption: chapter.description,
                  icon: "ballot",
                  done: step.value > chapter.chapter_number
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_list, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chapter.questions, (question) => {
                          return (_openBlock(), _createBlock(_component_q_item, {
                            key: question.number
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_Suspense, null, {
                                fallback: _withCtx(() => [
                                  _createVNode(AppLoader)
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(defineFieldType.value(question.type)), {
                                    context: question,
                                    onHoistAnswer: captureAnswer
                                  }, null, 40, ["context"]))
                                ]),
                                _: 2
                              }, 1024))
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_stepper_navigation, null, {
                      default: _withCtx(() => [
                        (chapter.chapter_number > 1)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              flat: "",
                              color: "primary",
                              icon: "arrow_back",
                              label: "Назад",
                              onClick: ($event: any) => (prevStep(chapter))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (chapter.chapter_number < totalSteps.value)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 1,
                              color: "accent",
                              icon: "arrow_forward",
                              label: "Далее",
                              onClick: ($event: any) => (nextStep(chapter))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (chapter.chapter_number === totalSteps.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createVNode(_component_q_btn, {
                                unelevated: "",
                                "no-caps": "",
                                ripple: false,
                                class: "gu-btn gu-btn-secondary",
                                label: "Продолжить позже",
                                onClick: continueLater
                              }),
                              _createVNode(_component_q_btn, {
                                unelevated: "",
                                "no-caps": "",
                                ripple: false,
                                class: "gu-btn gu-btn-primary",
                                label: "Завершить",
                                onClick: openFinishConfirm
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["name", "title", "caption", "done"]))
              }), 128)),
              (hasDesigns.value)
                ? (_openBlock(), _createBlock(_component_q_step, {
                    key: 0,
                    name: designStepNumber.value,
                    title: "Назначения",
                    caption: "Ознакомьтесь со списком назначений",
                    icon: "assignment",
                    done: step.value > designStepNumber.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_q_icon, {
                          name: "info",
                          size: "18px",
                          color: "primary"
                        }),
                        _cache[6] || (_cache[6] = _createElementVNode("span", null, "Если Вы недавно сдавали анализы или были у специалиста, упомянутого в списке назначений, можете заранее отказаться от этих услуг", -1))
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regularDesigns.value, (design) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: design.iddesign,
                            class: _normalizeClass(["design-card", { 'design-card--canceled': design.canceled }])
                          }, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(design.short_name), 1),
                            _createVNode(_component_q_btn, {
                              unelevated: "",
                              "no-caps": "",
                              ripple: false,
                              icon: design.canceled ? 'add' : 'close',
                              loading: processingDesignIds.value.includes(design.iddesign),
                              disable: processingDesignIds.value.includes(design.iddesign),
                              class: "gu-btn gu-btn-secondary gu-btn-sm",
                              label: design.canceled ? 'Вернуть' : 'Отказаться',
                              onClick: ($event: any) => (toggleDesign(design))
                            }, null, 8, ["icon", "loading", "disable", "label", "onClick"])
                          ], 2))
                        }), 128)),
                        (labDesigns.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "design-group-title" }, " Лабораторные назначения ", -1)),
                                _createVNode(_component_q_btn, {
                                  unelevated: "",
                                  "no-caps": "",
                                  ripple: false,
                                  icon: "close",
                                  loading: cancelingAllLab.value,
                                  disable: cancelingAllLab.value,
                                  class: "gu-btn gu-btn-secondary gu-btn-sm",
                                  label: "Отказаться от всех лабораторных назначений",
                                  onClick: cancelAllLabDesigns
                                }, null, 8, ["loading", "disable"])
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labDesigns.value, (design) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: design.iddesign,
                                  class: _normalizeClass(["design-card", { 'design-card--canceled': design.canceled }])
                                }, [
                                  _createElementVNode("div", _hoisted_9, _toDisplayString(design.short_name), 1),
                                  _createVNode(_component_q_btn, {
                                    unelevated: "",
                                    "no-caps": "",
                                    ripple: false,
                                    icon: design.canceled ? 'add' : 'close',
                                    loading: processingDesignIds.value.includes(design.iddesign),
                                    disable: processingDesignIds.value.includes(design.iddesign),
                                    class: "gu-btn gu-btn-secondary gu-btn-sm",
                                    label: design.canceled ? 'Вернуть' : 'Отказаться',
                                    onClick: ($event: any) => (toggleDesign(design))
                                  }, null, 8, ["icon", "loading", "disable", "label", "onClick"])
                                ], 2))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_q_stepper_navigation, null, {
                        default: _withCtx(() => [
                          (designStepNumber.value > 1)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                flat: "",
                                color: "primary",
                                icon: "arrow_back",
                                label: "Назад",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (step.value -= 1))
                              }))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_q_btn, {
                              unelevated: "",
                              "no-caps": "",
                              ripple: false,
                              class: "gu-btn gu-btn-secondary",
                              label: "Продолжить позже",
                              onClick: continueLater
                            }),
                            _createVNode(_component_q_btn, {
                              unelevated: "",
                              "no-caps": "",
                              ripple: false,
                              class: "gu-btn gu-btn-primary",
                              label: "Завершить",
                              onClick: openFinishConfirm
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["name", "done"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("aside", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(poll), (chapter) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: chapter.chapter_number,
                  class: _normalizeClass(["chapter-item", { active: step.value === chapter.chapter_number }]),
                  onClick: ($event: any) => (step.value = chapter.chapter_number)
                }, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(chapter.chapter_number), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(chapter.chapter), 1),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(chapter.description), 1)
                  ])
                ], 10, _hoisted_13))
              }), 128)),
              (hasDesigns.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["chapter-item", { active: step.value === designStepNumber.value }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (step.value = designStepNumber.value))
                  }, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(designStepNumber.value), 1),
                    _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                      _createElementVNode("div", { class: "chapter-title" }, " Назначения "),
                      _createElementVNode("div", { class: "chapter-subtitle" }, " Ознакомьтесь со списком назначений ")
                    ], -1))
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("main", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(poll), (chapter) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: chapter.chapter_number
                }, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(chapter.chapter), 1),
                  _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chapter.questions, (question) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: question.number,
                        class: "question-card"
                      }, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                          fallback: _withCtx(() => [
                            _createVNode(AppLoader)
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(defineFieldType.value(question.type)), {
                              context: question,
                              onHoistAnswer: captureAnswer
                            }, null, 40, ["context"]))
                          ]),
                          _: 2
                        }, 1024))
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    (chapter.chapter_number > 1)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          flat: "",
                          icon: "arrow_back",
                          color: "primary",
                          label: "Назад",
                          onClick: ($event: any) => (prevStep(chapter))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (chapter.chapter_number < totalSteps.value)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 1,
                          color: "accent",
                          icon: "arrow_forward",
                          label: "Далее",
                          onClick: ($event: any) => (nextStep(chapter))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (chapter.chapter_number === totalSteps.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createVNode(_component_q_btn, {
                            unelevated: "",
                            "no-caps": "",
                            ripple: false,
                            class: "gu-btn gu-btn-secondary",
                            label: "Продолжить позже",
                            onClick: continueLater
                          }),
                          _createVNode(_component_q_btn, {
                            unelevated: "",
                            "no-caps": "",
                            ripple: false,
                            class: "gu-btn gu-btn-primary",
                            label: "Завершить",
                            onClick: openFinishConfirm
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])), [
                  [_vShow, chapter.chapter_number === step.value]
                ])
              }), 128)),
              (hasDesigns.value)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "chapter-header" }, " Назначения ", -1)),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_q_icon, {
                        name: "info",
                        size: "18px",
                        color: "primary"
                      }),
                      _cache[9] || (_cache[9] = _createElementVNode("span", null, "Если Вы недавно сдавали анализы или были у специалиста, упомянутого в списке назначений, можете заранее отказаться от этих услуг", -1))
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regularDesigns.value, (design) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: design.iddesign,
                          class: _normalizeClass(["design-card", { 'design-card--canceled': design.canceled }])
                        }, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(design.short_name), 1),
                          _createVNode(_component_q_btn, {
                            unelevated: "",
                            "no-caps": "",
                            ripple: false,
                            icon: design.canceled ? 'add' : 'close',
                            loading: processingDesignIds.value.includes(design.iddesign),
                            disable: processingDesignIds.value.includes(design.iddesign),
                            class: "gu-btn gu-btn-secondary gu-btn-sm",
                            label: design.canceled ? 'Вернуть' : 'Отказаться',
                            onClick: ($event: any) => (toggleDesign(design))
                          }, null, 8, ["icon", "loading", "disable", "label", "onClick"])
                        ], 2))
                      }), 128)),
                      (labDesigns.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "design-group-title" }, " Лабораторные назначения ", -1)),
                              _createVNode(_component_q_btn, {
                                unelevated: "",
                                "no-caps": "",
                                ripple: false,
                                icon: "close",
                                loading: cancelingAllLab.value,
                                disable: cancelingAllLab.value,
                                class: "gu-btn gu-btn-secondary gu-btn-sm",
                                label: "Отказаться от всех лабораторных назначений",
                                onClick: cancelAllLabDesigns
                              }, null, 8, ["loading", "disable"])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labDesigns.value, (design) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: design.iddesign,
                                class: _normalizeClass(["design-card", { 'design-card--canceled': design.canceled }])
                              }, [
                                _createElementVNode("div", _hoisted_29, _toDisplayString(design.short_name), 1),
                                _createVNode(_component_q_btn, {
                                  unelevated: "",
                                  "no-caps": "",
                                  ripple: false,
                                  icon: design.canceled ? 'add' : 'close',
                                  loading: processingDesignIds.value.includes(design.iddesign),
                                  disable: processingDesignIds.value.includes(design.iddesign),
                                  class: "gu-btn gu-btn-secondary gu-btn-sm",
                                  label: design.canceled ? 'Вернуть' : 'Отказаться',
                                  onClick: ($event: any) => (toggleDesign(design))
                                }, null, 8, ["icon", "loading", "disable", "label", "onClick"])
                              ], 2))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      (designStepNumber.value > 1)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            flat: "",
                            icon: "arrow_back",
                            color: "primary",
                            label: "Назад",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (step.value -= 1))
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_q_btn, {
                          unelevated: "",
                          "no-caps": "",
                          ripple: false,
                          class: "gu-btn gu-btn-secondary",
                          label: "Продолжить позже",
                          onClick: continueLater
                        }),
                        _createVNode(_component_q_btn, {
                          unelevated: "",
                          "no-caps": "",
                          ripple: false,
                          class: "gu-btn gu-btn-primary",
                          label: "Завершить",
                          onClick: openFinishConfirm
                        })
                      ])
                    ])
                  ], 512)), [
                    [_vShow, step.value === designStepNumber.value]
                  ])
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: showFinishConfirm.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showFinishConfirm).value = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "gu-confirm-card" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_q_icon, {
                name: "description",
                size: "26px"
              })
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "gu-confirm-title" }, " Завершение анкетирования ", -1)),
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "gu-confirm-text" }, " По завершению будет создан документ на подпись. Уверены, что ответили на все вопросы? ", -1)),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_q_btn, {
                unelevated: "",
                "no-caps": "",
                ripple: false,
                disable: creatingPollFile.value,
                class: "gu-btn gu-btn-secondary",
                label: "Назад к вопросам",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showFinishConfirm.value = false))
              }, null, 8, ["disable"]),
              _createVNode(_component_q_btn, {
                unelevated: "",
                "no-caps": "",
                ripple: false,
                loading: creatingPollFile.value,
                disable: creatingPollFile.value,
                class: "gu-btn gu-btn-primary",
                label: "Подтвердить",
                onClick: confirmFinishPoll
              }, null, 8, ["loading", "disable"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})